import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { fetchCheckbooks, requestCheckbook, checkbookFees, cancelCheckbook, approvCheckbook, decliCheckbook } = endpoints;

/**
 * IB1-300 (épique #5428, F1.2/F5.1) : retourne l'historique complet des demandes de chéquier du
 * client (anciennes + en cours). Voir le commentaire sur `endpoints.fetchCheckbooks` pour le détail
 * de l'endpoint (confirmé par le backend le 11/09).
 */
const getCheckbooks = async (params: any) => {
  try {
    const response = await axios.get(fetchCheckbooks, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const createCheckbook = async (data: any, idempotencyKey: string) => {
  try {
    const response = await axios.post(requestCheckbook, data, { headers: { 'X-Idempotency-Key': idempotencyKey } });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const calculateCheckbookFees = async (checkbookTypeCode: string, accountId: string) => {
  try {
    const response = await axios.get(checkbookFees(checkbookTypeCode), { params: { accountId } });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const approveCheckbook = async (data: any) => {
  try {
    const response = await axios.post(approvCheckbook, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const declineCheckbook = async (data: any) => {
  try {
    const response = await axios.post(decliCheckbook, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const cancelRequest = async (id: string) => {
  try {
    const response = await axios.post(cancelCheckbook(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const checkbookServices = {
  getCheckbooks,
  createCheckbook,
  calculateCheckbookFees,
  cancelRequest,
  approveCheckbook,
  declineCheckbook,
};

export default checkbookServices;
